/**
 * System-wide Configuration Types
 * 
 * Globális rendszerbeállítások (Firestore: systemConfig collection)
 */

export interface MFAPolicy {
  required: boolean;              // MFA kötelező-e minden felhasználónak
  gracePeriodDays: number;        // Türelmi időszak napokban (pl. 7 nap)
  enforcedAt?: Date;              // Mikor lett kötelezővé téve
  exemptRoles?: string[];         // Kivételek (pl. ['customer'])
}

export interface SystemConfig {
  id: string;                     // 'global' - egyetlen dokumentum
  mfaPolicy: MFAPolicy;
  updatedAt: Date;
  updatedBy: string;              // Ki frissítette utoljára
}

export const DEFAULT_MFA_POLICY: MFAPolicy = {
  required: false,
  gracePeriodDays: 7,
  exemptRoles: ['customer']       // Ügyfelek alapértelmezetten mentesek
};
